/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import produce from 'immer';
import {
  GET_DANH_SACH_DON_HANG_DONE,
} from './constant';

export type QuanLyDonHangState = {
  listDonHang: any;
};

const initState: QuanLyDonHangState = {
  listDonHang: [],
};

const QuanLyDonHangReducer = (
  state = initState,
  action: ActionType,
): QuanLyDonHangState => {
  return produce(
    state,
    (draftState: QuanLyDonHangState): QuanLyDonHangState => {
      switch (action.type) {
        case GET_DANH_SACH_DON_HANG_DONE:
          draftState.listDonHang = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};

export default QuanLyDonHangReducer